module.exports = __webpack_public_path__ + "img/howto_insurancestaking_stake.ae502390.png";